/**
 * Tipos de documento de investidor conforme tabela oficial do backend
 * (GET /investor-document-type). Os códigos (code) acompanham cada tipo.
 */
export enum InvestorDocumentTypeEnum {
    /** RG (code: RG) */
    IdentityDocument = 1,
    /** CNH (code: CN) */
    Cnh = 2,
    /** CRNM (code: CR) */
    Crnm = 3,
    /** Passaporte (code: PA) */
    Passport = 4,
    /** Documento Assinado (code: DA) */
    SignedDocument = 5,
    /** Carteira de Identidade Nacional (code: CI) */
    NationalIdCard = 6,
    /** Comprovante de Residência (code: CE) */
    ProofOfAddress = 7,
    /** Contrato Social (code: CS) */
    ArticlesOfIncorporation = 8,
    /** Cartão CNPJ (code: CC) */
    CnpjCard = 9,
    /** Certidão de Último Ato (code: CA) */
    LastRegisteredActCertificate = 10,
    /** Documentos dos Representantes (code: DR) */
    RepresentativeDocuments = 11,
    /** Livro de Acionistas (code: LA) */
    ShareholderLedger = 12,
    /** Procuração (code: PR) */
    PowerOfAttorney = 13,
    /** Comprovante de Certificação (code: CF) — perfil qualificado/profissional. */
    Certification = 14,
    /** Documento de Compliance (code: DC) */
    Compliance = 15,
    /** Comprovante de Patrimônio (code: CP) */
    ProofOfEquity = 16,
}
